module.exports = __webpack_public_path__ + "img/GAME_BLOCKFLIP1.9dc44f1d.jpg";